import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-clientes-index',
  templateUrl: './clientes-index.component.html',
  styleUrls: ['./clientes-index.component.css']
})
export class ClientesIndexComponent {

  TipoUsuario=TipoUsuario;

  constructor(private authService:AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
